export const ADD_PROPERTY_UNITS_INFO_MESSAGE = 'Aggiungi le unità immobiliari';
